export default __webpack_public_path__ + "static/support-0d3908de414235e61777895114e2523f.webp";